import { render, staticRenderFns } from "./announcePage.vue?vue&type=template&id=824d34f4&scoped=true"
import script from "./announcePage.vue?vue&type=script&lang=js"
export * from "./announcePage.vue?vue&type=script&lang=js"
import style0 from "./announcePage.vue?vue&type=style&index=0&id=824d34f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824d34f4",
  null
  
)

export default component.exports